// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* head bar text color */
@font-face {
  color: #000;
  font-family: Roboto-Black;
  src: url("/assets/fonts/Roboto-Regular.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Bold;
  src: url("/assets/fonts/Roboto-Bold.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-SemiBold;
  src: url("/assets/fonts/Roboto-Bold.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Light;
  src: url("/assets/fonts/Roboto-Light.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Medium;
  src: url("/assets/fonts/Roboto-Medium.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Regular;
  src: url("/assets/fonts/Roboto-Regular.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Thin;
  src: url("/assets/fonts/Roboto-Thin.ttf") format("truetype");
}
:host.cs-nav-drop-down-opened:after {
  content: "";
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid #fff;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  position: absolute;
  top: 46px;
  margin-left: 10px;
}
:host .trigger {
  color: white;
}
:host .notification-badge {
  display: inline-block;
  padding: 0.3em 0.4em;
  font-size: 12px;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: bottom;
  border-radius: 1rem;
  background: var(--cs-primary-color);
  position: absolute;
  left: 13px;
  top: 11px;
}
:host .cs-nav-drop-down-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.4);
  cursor: pointer;
}
:host .notification {
  width: 18px;
  height: 18px;
}
:host .notification-content {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 62px;
  bottom: auto;
  right: 0;
  width: 450px;
  color: #4b5b70;
  background: #fff;
  transition: width 0.25s, background 0.25s;
  box-shadow: -3px 4px 6px 0 rgba(196, 196, 196, 0.4);
}
:host .notification-content .heading {
  padding: 1rem 1.5rem;
  display: flex;
}
:host .notification-content .heading button {
  margin-left: auto;
}
:host .notification-content .notification-box {
  max-height: 400px;
  overflow: auto;
  padding: 0 1.5rem;
}
:host .notification-content .notification-box h6 {
  margin-bottom: 0;
}
:host .notification-content .notification-box p {
  color: #4b5b70;
  margin-bottom: 0.4rem;
}
:host .notification-content .notification-box .message {
  text-decoration: none;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #ddd;
  padding: 0.75rem 0;
  color: #4b5b70;
}
:host .notification-content .notification-box .message .clear {
  opacity: 0;
  transition: all 100ms ease-in;
}
:host .notification-content .notification-box .message:hover .clear {
  opacity: 1;
}
:host .notification-content .notification-box .message:last-child {
  border-bottom: 0;
}
:host .notification-content .notification-box .message .notify-unread h6 {
  font-family: Roboto-SemiBold;
}
:host .notification-content .notification-box .message .notify-unread p {
  font-family: Roboto-SemiBold;
}
:host .notification-content .notification-box .message .notify-read h6 {
  font-family: Roboto-Regular;
}
:host .notification-content .notification-box .message .notify-read p {
  font-family: Roboto-Regular;
}
:host .notification-content .note-message {
  font-size: 12px;
}
:host .notification-content h5 {
  margin-bottom: 0;
  color: #4b5b70;
  font-family: Roboto-Regular;
}
:host .notification-content .view-more {
  text-decoration: none;
  text-align: center;
  border-top: 1px solid #fafafa;
  margin: 0 auto;
  padding: 1rem 1.5rem;
}
:host .notification-content .view-more:hover {
  color: var(--cs-primary-color);
}
:host .notification-content .no-more:hover {
  color: #000;
}
:host .no-notifications {
  width: 110px;
  margin: 2rem auto;
  text-align: center;
}
:host .no-notifications p {
  margin-top: 1rem;
}
:host .no-notifications cs-icon {
  width: 100%;
  height: 100%;
}
:host .unread-notifications {
  font-size: Roboto-Medium;
}
:host .dot {
  height: 10px;
  width: 10px;
  background-color: var(--cs-primary-color);
  border-radius: 50%;
  display: inline-block;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
